import { render } from "./profile_sidebar.vue?vue&type=template&id=1ba7debf&ts=true"
import script from "./profile_sidebar.vue?vue&type=script&lang=ts"
export * from "./profile_sidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__